<template>
  <hm-content title="活动详情">
    <div class="detail-container">
      <div class="activity mb20">
        <div class="caption">基础信息</div>
        <ul>
          <li class="flex">
            <div class="title">活动名称：</div>
            <div class="content">{{ subActivityDetails.actName }}</div>
          </li>
          <li class="flex" v-if="activityLabel.length">
            <div class="title">活动标签：</div>
            <div class="content">{{ actLabelName }}</div>
          </li>
          <li class="flex" v-if="couponTypes.length">
            <div class="title">关联发券：</div>
            <div class="content">
              <span v-for="(v, i) in couponTypes" :key="i">
                <span v-if="i">;</span> {{ v }}</span
              >
            </div>
          </li>
          <li class="flex">
            <div class="title">活动日期：</div>
            <div class="content">
              {{
                subActivityDetails.actStartTime
                  ? subActivityDetails.actStartTime.split(" ")[0]
                  : ""
              }}
              至
              {{
                subActivityDetails.actEndTime
                  ? subActivityDetails.actEndTime.split(" ")[0]
                  : ""
              }}
            </div>
          </li>
          <li class="flex">
            <div class="title">报名时间：</div>
            <div class="content">
              {{ subActivityDetails.applyStartTime }} 至
              {{ subActivityDetails.applyEndTime }}
            </div>
          </li>
          <li class="flex" v-if="regionNames.length">
            <div class="title">指定区域：</div>
            <div class="content flex-1">{{ regionNames }}</div>
          </li>
          <li class="flex">
            <div class="title">活动地点：</div>
            <div class="content">{{ subActivityDetails.actSite }}</div>
          </li>

          <li class="flex">
            <div class="title">适合人群：</div>
            <div class="content">{{ subActivityDetails.suitPerson }}</div>
          </li>
          <li class="flex">
            <div class="title">报名情况：</div>
            <div class="content">
              {{ subActivityDetails.realApplyNum || 0 }} /
              {{ subActivityDetails.actMemberUpperLimit }} 人
            </div>
          </li>
          <li class="flex">
            <div class="title">活动状态：</div>
            <div class="content">
              <span v-if="subActivityDetails.actStatus == 1" class="success"
                >开启</span
              >
              <span v-if="subActivityDetails.actStatus == 0" class="danger"
                >关闭</span
              >
            </div>
          </li>
          <li class="flex">
            <div class="title">是否显示活动：</div>
            <div class="content">
              <span v-if="subActivityDetails.isShow == 'yes'" class="success"
                >显示</span
              >
              <span v-if="subActivityDetails.isShow == 'no'" class="danger"
                >隐藏</span
              >
            </div>
          </li>
          <li class="flex">
            <div class="title">活动网址：</div>
            <div class="content flex-1">
              <span style="word-break: break-all;">
                {{ subActivityDetails.shareUrl }}
              </span>
            </div>
          </li>
          <li class="flex" v-if="subActivityDetails.formStatus === 'open'">
            <div class="title">报名表单：</div>
            <div class="content flex-1">
              <el-table
                stripe
                :data="subActivityDetails.columnsInfoModels"
                style="width: 100%"
                id="table"
                size="small"
                border
              >
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column
                  header-align="center"
                  prop="columnName"
                  label="报名项名称"
                >
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.columnName }}
                    </div>
                    <div
                      class="flex item-center ml10 mt10 zu"
                      v-if="
                        scope.row.columnType === 'radio' ||
                          scope.row.columnType === 'checkbox'
                      "
                      v-for="(v, i) in scope.row.paramInfoModels"
                      :key="i"
                    >
                      <div
                        class="marker mr10"
                        v-if="scope.row.columnType === 'radio'"
                      ></div>
                      <div
                        class="square mr10"
                        v-if="scope.row.columnType === 'checkbox'"
                      ></div>
                      <div>
                        {{ v.columnValue }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="报名项限制"
                >
                  <template slot-scope="scope">
                    <div v-if="scope.row.columnType === 'text'">
                      <div v-if="scope.row.validRule === 'phone'">
                        手机号
                      </div>
                      <div v-else-if="scope.row.validRule === 'number'">
                        数字
                      </div>
                      <div v-else>
                        文本
                      </div>
                    </div>
                    <div v-if="scope.row.columnType === 'date'">
                      日期
                    </div>
                    <div v-if="scope.row.columnType === 'radio'">
                      单选题
                    </div>
                    <div v-if="scope.row.columnType === 'checkbox'">
                      多选题
                    </div>
                    <div v-if="scope.row.columnType === 'picture'">
                      图片
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="wxshopSpuName"
                  label="是否必填"
                >
                  <template slot-scope="scope">
                    {{ scope.row.columnMustInput === "yes" ? "是" : "否" }}
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="wxshopSpuName"
                  label="是否可重复"
                >
                  <template slot-scope="scope" v-if="scope.row.columnType === 'text'">
                    {{ scope.row.repeatedState === "yes" ? "可重复" : "不可重复" }}
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="dataLength"
                  label="内容长度限制"
                >
                </el-table-column>
              </el-table>
            </div>
          </li>
        </ul>
      </div>
      <div class="activity mb20">
        <div class="caption">报名场次</div>
        <ul>
          <li
            class="mb20 borderB"
            v-for="(item, index) in subActivityDetails.roundBo"
            :key="index"
          >
            <div class="title mb20">
              <!-- <span v-if="item.actAddressType==='address'">活动地点:</span> -->
              <!-- <span v-if="item.actAddressType==='shop'">活动门店:</span> -->
            </div>
            <div class="content mb20">
              <!-- 活动地点 -->
              <div>活动地点：{{ item.actSite || '暂无' }}</div>

              <!-- 商店类型 -->
              <div class="mt10 mb10">
                商店类型：
                <span v-if="item.actShopType === 'all'">全部商店</span>
                <span v-else-if="item.actShopType === 'join'">加盟店</span>
                <span v-else-if="item.actShopType === 'self'">直营店</span>
                <span v-else>直营店</span>
              </div>

              <!-- 活动门店 - 使用StoreSelector只读模式展示 -->
              <div>
                <StoreSelector
                  :store-list="item.actShopList"
                  :all-stores="allAvailableStores"
                  :store-code="storeCode"
                  :store-type="item.actShopType"
                  :readonly="true"
                />
              </div>
            </div>

            <div class="title mb20">
              报名支付模式:{{
                item.costType === "both"
                  ? "同时支付（积分加货币同时支付）"
                  : "二选一支付（积分支付或者货币支付）"
              }}
            </div>

            <ul class="content">
              <li
                class="flex"
                v-for="(i, index) in item.subscribeRound"
                :key="index"
              >
                <div class="mr10">活动场次：{{ i.actRound }}</div>
                <div class="mr10">活动费用：{{ i.actCostMoney }}元</div>
                <div class="mr10">活动积分：{{ i.actCostIntegral }}积分</div>
                <div class="mr10">
                  场次报名情况：{{ i.registeredAmount }} /
                  {{ i.onceActMemberUpperLimit }}
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="activity mb20">
        <div class="caption">活动宣传图</div>
        <ul>
          <li class="flex">
            <div class="title">主图：</div>
            <div class="content flex-1">
              <img :src="subActivityDetails.mainImgUrl" alt />
            </div>
          </li>
          <li class="flex">
            <div class="title">轮播图：</div>
            <div class="content flex-1">
              <div
                v-for="(item, index) in subActivityDetails.subscribeCarousel"
                :key="index"
              >
                <img :src="item.carouselImgUrl" alt />
              </div>
            </div>
          </li>
          <li class="flex">
            <div class="title">活动详情：</div>
            <div class="content flex-1">
              <div class="ql-container ql-snow">
                <div class="ql-editor">
                  <div v-html="subActivityDetails.actDesc"></div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="btn-wrapper flex flex-center">
      <el-button
        size="small"
        type="primary"
        v-if="isWaitAudit && !mode"
        @click="switchAuditState('audit_pass')"
        >通过</el-button
      >
      <el-button
        size="small"
        type="primary"
        v-if="isWaitAudit && !mode"
        @click="switchAuditState('reject')"
        >驳回</el-button
      >
      <el-button size="small" @click="back">返回</el-button>
    </div>
  </hm-content>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
import { mapGetters } from "vuex";
import area from "@/utils/area";
import StoreSelector from "@/components/store-selector/StoreSelector";
export default {
components: { StoreSelector },
  data() {
    return {
      mode: "",
      previewDiaogVisible: false,
      keyWord: "",
      discountMode: "",
      storeOutletId: "",
      serverId: "",
      status: "",
      currentPage: 1,
      startDate: "",
      endDate: "",
      dateAndTime: "",
      pageSize: 10,
      isWaitAudit: false,
      id: "",
      storeCode: "",
      activityAddress: "",
      btnList: [
        { name: "全部" },
        { name: "已预约" },
        { name: "已付款" },
        { name: "消费中" },
        { name: "服务结束" },
        { name: "取消预约" },
        { name: "已驳回" }
      ],
      details: {
        basicConfigInfo: {},
        dateConfigInfo: {},
        dateConfigRange: {},
        fullDiscountRule: [],
        pasCalendars: [],
        pasGoods: [],
        pasLabels: [],
        pasOutlets: []
      },
      activityLabel: [],
      actLabelName: "",
      couponTypes: []
    };
  },
  computed: {
    ...mapGetters(["subActivityDetails", "microShopStoreList", "dkMicroShopStoreList"]),
    // 获取所有可用门店列表
    allAvailableStores() {
      const { storeCode } = getLoginUser();
      if (storeCode === '53010017032439' || storeCode === '42010216070190') {
        return this.dkMicroShopStoreList || [];
      }
      return this.microShopStoreList || [];
    },
    regionNames() {
      const list = this.subActivityDetails.pasSubscribeActivityAddressRelModelList || [];
      if (!list.length) return "";
      
      const regionNameList = [];
      
      list.forEach(cityData => {
        const { provinceCode, cityCode, districtCodeList } = cityData;
        const districtCodes = districtCodeList ? districtCodeList.split(',') : [];
        
        // 查找省市区名称
        const province = area.find(p => p.value === provinceCode);
        const city = province && province.children ? province.children.find(c => c.value === cityCode) : null;
        
        if (province && city) {
          districtCodes.forEach(districtCode => {
            const district = city.children ? city.children.find(d => d.value === districtCode) : null;
            if (district) {
              regionNameList.push(`${province.label}-${city.label}-${district.label}`);
            }
          });
        }
      });
      
      return regionNameList.join('；');
    }
  },
  mounted() {
    const { id, couponTypes } = this.$route.query;
    this.couponTypes = JSON.parse(couponTypes) || [];
    this.$store.dispatch("subActivityDetails", { id });
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;

    // 加载门店列表
    if (storeCode === '53010017032439' || storeCode === '42010216070190') {
      this.$store.dispatch("queryDkMicroStoreList");
    } else {
      this.$store.dispatch("queryMicroStoreList");
    }

    this.activityAddress = `http://hx.hemiao100.com/dist/#/activity/activityDetails/${storeCode}/${id}`;
    this.queryActivityLabel();
  },
  watch: {
    // 监听详情数据变化，处理门店信息
    subActivityDetails: {
      handler(newVal) {
        if (newVal && newVal.roundBo) {
          this.processStoreData(newVal.roundBo);
        }
      },
      immediate: true
    }
  },
  methods: {
    // 处理门店数据，兼容历史数据
    processStoreData(roundBo) {
      roundBo.forEach(v => {
        // 兼容历史数据：根据actAddressType字段处理门店信息
        if (v.actAddressType) {
          // 历史数据有actAddressType字段
          if (v.actAddressType === 'shop') {   
            // 门店类型：将actSite转换为门店数组
            if (v.actSite && typeof v.actSite === 'string') {
              // 判断是否为"全部门店"
              if (v.actSite === '全部门店') {
                // 全部门店：选中所有门店
                v.actShopName = this.allAvailableStores.map(store => store.shopName);
              } else {
                // 普通门店列表：按逗号分割
                v.actShopName = v.actSite.split(',');
              }
            } else {
              v.actShopName = [];
            }
            v.actSite = ''; // 门店类型下清空actSite（详情页保留显示）
          } else if (v.actAddressType === 'address') {
            // 地址类型：actSite保持不变，清空门店信息
            v.actShopName = [];
          }
        } else {
          // 新数据没有actAddressType字段，直接处理actShopName
          if (v.actShopName && typeof v.actShopName === 'string') {
            v.actShopName = v.actShopName.split(',');
          }
        }

        // 初始化actShopList数组
        if (!v.actShopList) {
          this.$set(v, 'actShopList', []);
        }

        // 初始化actShopType，默认为self
        if (!v.actShopType) {
          this.$set(v, 'actShopType', 'self');
        }

        // 根据shopName从allAvailableStores中匹配完整的门店对象
        if (v.actShopName && Array.isArray(v.actShopName)) {
          v.actShopList = v.actShopName.map(shopName => {
            return this.allAvailableStores.find(store => store.shopName === shopName);
          }).filter(store => store !== undefined); // 过滤掉未找到的门店
        }
      });
    },
    async queryActivityLabel() {
      const { result } = await this.$store.dispatch("queryActivityLabel");
      if (result && result.length) {
        this.activityLabel = result;
        let actLabelName = this.activityLabel.find(
          o => o.itemValue === this.subActivityDetails.activityLabel
        );
        if (actLabelName) {
          this.actLabelName = actLabelName.itemText;
        }
      }
    },
    switchAuditState(auditState) {
      if (auditState === "reject") {
        this.$confirm("驳回当前促销?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$store
            .dispatch("switchAuditState", {
              id: this.id,
              auditState
            })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.$router.back(-1);
              }
            });
        });
      } else {
        this.$store
          .dispatch("switchAuditState", {
            id: this.id,
            auditState
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
      }
    },
    back() {
      this.$router.back(-1);
    }
  }
};
</script>

<style scoped lang="scss">
.borderB {
  border-bottom: 1px solid #d8dce5;
}
.caption {
  position: relative;
  padding-left: 10px;
  color: #000;
  margin-bottom: 20px;
  &::before {
    position: absolute;
    left: 0;
    width: 4px;
    height: 100%;
    background: #e50065;
    content: "";
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}

.status {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-right: 10px;
}

.detail-container {
  font-size: 14px;
  .title {
    color: #000;
    margin-right: 20px;
  }
  li {
    line-height: 30px;
  }
  .content {
    color: #999;
    > div {
      margin-bottom: 10px;
    }
  }
}
.marker {
  width: 14px;
  height: 14px;
  border: 1px solid #d2d6df;
  border-radius: 50%;
  opacity: 0.5;
}
.square {
  width: 14px;
  height: 14px;
  border: 1px solid #d2d6df;
  opacity: 0.5;
}
</style>
